<template>
    <div id="app-container" class="app-container-box">
      <div class="message-detail-box">
        <div class="detail-content" v-html="msgDetailInfo" v-if="content_type == 1">
          
        </div>
        <iframe :src="msgDetailInfo" class="iframe_box" frameborder="no" border="0" marginwidth="0" marginheight="0"  allowtransparency="yes" v-else></iframe>
      </div>
    </div>
  </template>
  <script setup>
  import { ref, onMounted } from "vue";
  import { useRouter } from "vue-router";
  
  const router = useRouter();
  const msgDetailInfo = ref("");
  const content_type = ref(1)
  
  onMounted(() => {
    const { content, type } = router.currentRoute.value.query;
    msgDetailInfo.value = content
    content_type.value = type
  });
  
  </script>
  <style lang="scss" scoped>
  .app-container-box {
    // padding: 16px;
     width: 100vw;
     height: 100vh;
    .iframe_box{
       width: 100vw;
       height: 100vh;
    }
    .message-detail-box {
      .detail-content {
         margin: 16px;
         padding: 16px;
         background-color: white;
         border-radius: 16px;
         box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
         /deep/ p {
          word-break: break-all;
         }
         /deep/ img {
            max-width: 100%;
          }
      }
    }
  }
  </style>
  